import { InjectionToken } from '@angular/core';
import { SeoConfig } from '@common';

export const SEO_CONFIG = new InjectionToken<SeoConfig>('SEO Config');
